module.exports = __webpack_public_path__ + "img/51626498_L.884e6b82.png";